<template>
  <div id="app">
    <block-header id="header" v-on="block_handlers"></block-header>
    <block-main v-on="block_handlers"></block-main>
    <running-line v-on="block_handlers"></running-line>
    <block-clock v-on="block_handlers"></block-clock>
    <block-advantages v-on="block_handlers"></block-advantages>
    <block-cars v-on="block_handlers"></block-cars>
    <!-- <block-offer v-on="block_handlers"></block-offer> -->
    <!-- <block-credit-new v-on="block_handlers" /> -->
    <block-advantages-bottom id="advantages-bottom" v-on="block_handlers" />
    <block-contacts id="contacts" v-on="block_handlers"></block-contacts>
    <block-footer></block-footer>

    <cookie-notification />

    <full-get
      v-show="show.get"
      @close="closeThings"
      v-on="block_handlers"
      :custom_text="data.text"
    >
    </full-get>
    <full-slider
      v-show="show.slider"
      @close="closeThings"
      v-on="block_handlers"
      :slides="slides"
      :activeIndex="activeIndex"
    ></full-slider>
    <!-- <full-agreement v-show="show.agreement" @close="closeAgreement">
    </full-agreement> -->
    <full-thanks v-if="show.thanks" @close="show.thanks = false"> </full-thanks>
    <preloader v-if="show.load"></preloader>
  </div>
</template>

<script>
import BlockHeader from "./components/block-header";
import BlockMain from "./components/block-main";
import RunningLine from './components/running-line.vue';
import BlockClock from "./components/block-clock";
import BlockCars from './components/block-cars/block-cars.vue';
import BlockAdvantages from "./components/block-advantages";
import BlockOffer from "./components/block-offer.vue";
import BlockContacts from "./components/block-contacts";
import BlockLegal from "./components/block-legal";
import BlockFooter from "./components/block-footer";
import FullGet from "./components/full-get";
import FullThanks from "./components/full-thanks";
import Mixin from "./common/mixin";
import Preloader from "./components/preloader";
import CookieNotification from "@/components/cookie-notification.vue";

import Send from "./common/send";

import $ from "jquery";

import smoothScrollTo from "./common/smoothScrollTo";
import BlockAdvantagesBottom from "./components/block-advantages-bottom.vue";
import BlockCreditNew from "./components/block-credit-new.vue";
import FullSlider from "./components/full-slider.vue";

export default {
  name: "app",
  components: {
    BlockHeader,
    BlockAdvantages,
    BlockFooter,
    BlockContacts,
    BlockMain,
    RunningLine,
    BlockCars,
    FullGet,
    // FullAgreement,
    FullThanks,
    Preloader,
    BlockClock,
    BlockOffer,
    BlockAdvantagesBottom,
    BlockCreditNew,
    FullSlider,
    CookieNotification,
  },
  mixins: [Mixin],
  data: function () {
    return {
      show: {
        thanks: false,
        get: false,
        slider: false,
        agreement: false,
        load: false,
      },
      slides: [],
      activeIndex: 0,
      data: {},
    };
  },
  mounted() {
    $("html").on("keyup", (event) => {
      if (event.keyCode === 27) {
        this.closeThings();
      }
    });

    // window.ctw_phones = [];

    if (window.location.hash === "#credit") {
      this.scrollTo("credit");
    } else if (window.location.hash.length) {
      this.scrollTo("credit");
    }
  },
  computed: {
    block_handlers() {
      return {
        getAgreement: this.handleGetAgreement,
        scrollTo: this.scrollTo,
        callBack: this.callThere,
        getCall: this.handleGetCall,
        getFullSlider: this.handleGetSlider,
      };
    },
  },
  methods: {
    closeThings() {
      this.show.get = false;
      this.show.thanks = false;
      this.show.agreement = false;
      this.show.slider = false;
      this.data = {};
      this.slides = [];
      this.activeIndex = 0;
      this.unblockScroll();
    },
    closeAgreement() {
      this.show.agreement = false;
      let has_show = false;
      for (let key in this.show) {
        if (this.show[key]) {
          has_show = true;
        }
      }
      if (!has_show) {
        this.unblockScroll();
      }
    },
    handleGetCall(data) {
      this.show.get = true;
      this.data = data;
      this.blockScroll();
      ym(99537255,'reachGoal','open_form');
    },
    handleGetSlider({ slides, activeIndex }) {
      this.slides = slides;
      this.activeIndex = activeIndex;
      this.show.slider = true;
      this.blockScroll();
    },
    handleGetAgreement() {
      this.show.agreement = true;
      this.blockScroll();
    },
    scrollTo(where) {
      smoothScrollTo(
        $("#" + where).offset().top -
          (this.device_platform === "desktop" ? 100 : 25)
      );
    },
    callThere(event) {
      const finishCall = () => {
        this.closeThings();
        this.show.load = false;
        this.show.thanks = true;
        if (typeof window.dataLayer !== "undefined") {
          window.dataLayer.push({
            event: "callkeeper-call_order-ckaction",
            eventCategory: "callkeeper",
            eventAction: "call_order",
            eventLabel: "ckaction",
          });
        }
        console.log("done");
      };

      let req = Send(event, this.data);
      this.show.load = true;
      if (!req) {
        finishCall();
      } else {
        req.finally(finishCall);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.interblock-space_tiny {
  height: 5px;
}

.interblock-space_small {
  height: 60px;
}

.interblock-space_medium {
  height: 135px;
}
</style>
